import { Component, OnInit, Input } from '@angular/core';
import { LessonList, LessonListService } from 'src/app/core/http/lessonList/lesson-list.service';
import { ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { BreadcrumbService } from 'angular-crumbs';
import { TaskListService } from 'src/app/core/http/taskList/task-list.service';

@Component({
  selector: 'app-lesson-list',
  templateUrl: './lesson-list.component.html',
  styleUrls: ['./lesson-list.component.css']
})
export class LessonListComponent implements OnInit {
  @Input() lessons: LessonList[];

  enableEdit = false;
  enableEditIndex = null;

  percent = (6/44)*100;

  constructor(private taskListService: TaskListService) {
    
  }

  ngOnInit() {
  }

  openTasks(i, lesson) {
    if (this.enableEdit && this.enableEditIndex == i) {
      this.closeTasks();
      return;
    }
    this.enableEdit = true;
    this.enableEditIndex = i;
    if (lesson['tasks'] === undefined) {
      this.taskListService.getAll(lesson.id)
      .subscribe(resp=> {
        lesson['tasks']=resp;
        console.log(resp);
      })
    } else {
      console.log('1');
    }
  }
  closeTasks() {
    this.enableEdit = false;
    this.enableEditIndex = null;
  }


}
